<mat-dialog-content>
  <div class="dialog-content-container">

    <div class="dialog-title text-center mb-4">{{ title }}</div>

    <!-- Search Section -->
    <div class="search-section mb-3">
      <mat-form-field floatLabel="always" appearance="outline" class="w-100 search-field">
        <mat-label>Search by Staff No, Username, or Name</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput
               [(ngModel)]="searchTerm"
               (keydown.enter)="search($event)"
               type="text"
               [disabled]="isSearching"
               placeholder="Enter staff number, username, or name">
        <button mat-icon-button matSuffix
                *ngIf="searchTerm && !isSearching"
                (click)="clearSearch()">
          <mat-icon>clear</mat-icon>
        </button>
        <mat-icon matSuffix *ngIf="isSearching">
          <mat-spinner diameter="20"></mat-spinner>
        </mat-icon>
      </mat-form-field>
    </div>

    <!-- Search Results List -->
    <div *ngIf="showSearchResults && searchResults.length > 0" class="search-results mb-3">
      <h6 class="text-muted mb-2">Search Results ({{ searchResults.length }})</h6>
      <div class="results-list">
        <div *ngFor="let result of searchResults"
             class="result-item p-3 mb-2 border rounded"
             (click)="selectStaff(result)">
          <div class="staff-primary-info mb-2">
            <span class="badge bg-primary me-2">{{ result.staffNo }}</span>
            <span class="fw-bold">{{ result.staffName }}</span>
            <span class="text-muted ms-2">@{{ result.username }}</span>
          </div>
          <div class="staff-secondary-info d-flex gap-3 flex-wrap">
            <div class="merchant-badge">
              <mat-icon [class.text-primary]="result.fromBranch" [class.text-success]="!result.fromBranch">
                {{ result.fromBranch ? 'business' : 'home' }}
              </mat-icon>
              <span class="small">{{ result.merchantDisplayName }}</span>
            </div>
            <div class="balance-badge">
              <mat-icon class="text-success">account_balance_wallet</mat-icon>
              <span class="small">Balance: RM {{ result.balance | number:'1.2-2' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Selected Staff Display -->
    <div class="selected-staff py-3 px-3 highlight-background rounded mb-3" *ngIf="selectedStaff && staffMeal">
      <div class="d-flex align-items-center mb-3">
        <div class="symbol-circle me-3">{{ selectedStaff.staffName?.charAt(0).toUpperCase() }}</div>
        <div class="flex-grow-1">
          <span class="staff-name text-dark fw-bold fs-5">{{ selectedStaff.staffName }}</span>
          <span class="text-muted small ms-2">({{ selectedStaff.staffNo }})</span><br>
          <span class="text-muted small">@{{ selectedStaff.username }}</span>
        </div>
        <button class="btn btn-sm btn-outline-secondary" (click)="clearSearch()">
          <i class="fa fa-times"></i> Clear
        </button>
      </div>

      <!-- Merchant Information -->
      <div class="merchant-info mb-2">
        <div class="d-flex align-items-center gap-2">
          <mat-icon [class.text-primary]="isFromBranch" [class.text-success]="!isFromBranch" class="small-icon">
            {{ isFromBranch ? 'business' : 'home' }}
          </mat-icon>
          <span class="text-muted small">Outlet:</span>
          <span class="fw-semibold small">{{ merchantDisplayName }}</span>
        </div>
      </div>

      <hr class="my-2">

      <!-- Balance Information -->
      <div class="balance-info">
        <div class="row mb-2">
          <div class="col-6">
            <span class="text-muted">Total Allowance:</span>
          </div>
          <div class="col-6 text-end">
            <span class="fw-semibold">RM {{ staffMeal.totalAmount | number:'1.2-2' }}</span>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-6">
            <span class="text-muted">Available Balance:</span>
          </div>
          <div class="col-6 text-end">
            <span class="fw-bold text-primary fs-5">RM {{ staffMeal.balance | number:'1.2-2' }}</span>
          </div>
        </div>
      </div>

      <hr class="my-2">

      <!-- Deduction Calculation -->
      <div class="deduction-info">
        <div class="row mb-2">
          <div class="col-6">
            <span class="text-muted">Order Total:</span>
          </div>
          <div class="col-6 text-end">
            <span class="fw-semibold">RM {{ data.totalAmount | number:'1.2-2' }}</span>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-6">
            <span class="text-success fw-bold">Staff Meal Deduction:</span>
          </div>
          <div class="col-6 text-end">
            <span class="fw-bold text-success fs-5">- RM {{ staffMealAmount | number:'1.2-2' }}</span>
          </div>
        </div>
        <div class="row" *ngIf="remainingAmount > 0">
          <div class="col-6">
            <span class="text-warning fw-bold">Remaining to Pay:</span>
          </div>
          <div class="col-6 text-end">
            <span class="fw-bold text-warning fs-5">RM {{ remainingAmount | number:'1.2-2' }}</span>
          </div>
        </div>
        <div class="row" *ngIf="remainingAmount <= 0">
          <div class="col-12 text-center">
            <span class="text-success fw-bold">
              <i class="fa fa-check-circle me-1"></i> Full amount covered by staff meal
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- No balance warning -->
    <div class="alert alert-warning mb-3" *ngIf="staffMeal && staffMeal.balance <= 0">
      <i class="fa fa-exclamation-triangle me-2"></i>
      No staff meal balance available. The full amount must be paid with other methods.
    </div>

    <!-- Empty State -->
    <div class="empty-state text-center py-5" *ngIf="!showSearchResults && !staffMeal">
      <mat-icon class="empty-icon mb-3">search</mat-icon>
      <p class="text-muted">Search for a staff member to view their meal allowance</p>
    </div>

  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="action-buttons-container d-flex justify-content-center w-100 p-3">
    <div class="cancel-button-container col-4 me-3">
      <button class="btn btn-light border-0 fw-semibold mb-0 d-block py-3 w-100" mat-dialog-close="">
        <i class="fa fa-times-circle me-2"></i>
        <span>Cancel</span>
      </button>
    </div>
    <div class="action-button-container col-8" *ngIf="!staffMeal">
      <button
        class="btn btn-primary text-white w-100 h-100 d-flex align-items-center justify-content-center py-3"
        (click)="search()"
        [disabled]="!searchTerm || isSearching">
        <span>{{ isSearching ? 'Searching...' : 'Search' }}</span>
      </button>
    </div>
    <div class="action-button-container col-8" *ngIf="staffMeal">
      <button
        class="btn btn-success text-white w-100 h-100 d-flex align-items-center justify-content-center py-3"
        (click)="submit()"
        [disabled]="staffMealAmount <= 0">
        <i class="fa fa-check-circle me-2"></i>
        <span>Apply Staff Meal</span>
      </button>
    </div>
  </div>
</mat-dialog-actions>
